import actions from '../actions/actionTypes';

const INITIAL_STATE = {
  restrictionsMap: {},
  restrictionsLoading: false,
  error: null,
};

const productRestrictions = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.VENDOR_DELIVERY_DATE_RESTRICTIONS_LOADING:
      return {
        ...state,
        restrictionsLoading: true,
      };
    case actions.VENDOR_DELIVERY_DATE_RESTRICTIONS_SUCCESS:
      return {
        ...state,
        restrictionsLoading: false,
        restrictionsMap: {
          ...state.restrictionsMap,
          [payload.vendorId]: payload.restrictions,
        },
      };
    case actions.VENDOR_DELIVERY_DATE_RESTRICTIONS_ERROR:
      return {
        ...state,
        restrictionsLoading: false,
        error: payload.error,
      };
    case actions.VENDOR_DELIVERY_DATE_RESTRICTIONS_CLEAR:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default productRestrictions;
